import 'core-js/stable';
import 'regenerator-runtime/runtime';
import 'proxy-polyfill';

import 'rpf/react/vconsole';
import 'index.css';

import React from 'react';
import ReactDOM from 'react-dom';
import { Router } from 'react-router-dom';

import App from 'App';
import api from 'api';
import history from './history';
import { setConfig } from 'configs';
import preventScroll from 'rpf/un/preventScroll';
import FrontConfigSdk from 'rpf/un/FrontConfigSdk';
import disableWeChatFontSize from './rpf/un/disableWeChatFontSize';
import loadSentry from 'rpf/un/loadSentry';
import fixIOSForm from 'rpf/un/fixIOSForm';

disableWeChatFontSize();
preventScroll();
fixIOSForm();

new FrontConfigSdk({ id: 36 })
  .getConfig()
  .then(res => {
    const conf = res.conf;
    console.log(conf);
    api.setBaseUrl(conf.api.prodUrl);
    setConfig(conf);

    loadSentry(conf.sentry.dsn)
      .then(() => {
        ReactDOM.render(
          <React.StrictMode>
            <Router history={history}>
              <App />
            </Router>
          </React.StrictMode>,
          document.getElementById('root')
        );
      })
      .catch(err => {
        console.log('load sentry error', err);
      });
  })
  .catch(err => {
    console.log('FrontConfigSdk error', err.message);
  });
